import React from 'react'

const MailToHelp = () => (
  <a href='mailto:support@15five.com'>support@15five.com</a>
)

export default MailToHelp
